@if (enableCalendarSync && isLanguageBirdUser()) {
	@if (isSynced()) {
		<button md-button (click)="disableSync()" [disabled]="loading()" [title]="'Expires on ' + (calendarTokenStatus()?.expiresDate | date: 'mediumDate')">
			@if (loading()) {
				<md-icon [icon]="'untitled-ui/time/calendar'"></md-icon>
				Loading...
			} @else {
				<md-icon [icon]="'untitled-ui/time/calendar-minus-02'"></md-icon>
				Disable Sync
			}
		</button>
	} @else {
		<button md-button-info (click)="syncCalendar()" [disabled]="loading()">
			@if (loading()) {
				<md-icon [icon]="'untitled-ui/time/calendar'"></md-icon>
				Syncing...
			} @else {
				<md-icon [icon]="'untitled-ui/time/calendar-plus-02'"></md-icon>
				Sync Calendar
			}
		</button>
	}
}
